import * as React from 'react';
import useClientFromUrl from 'core/ui/utils/useClientFromUrl';
import {
  Channel as ChannelEntity,
  EmailChannel,
  getEmailChannel,
  ScheduledChannel,
  TemplateChannel,
} from 'entities/campaign/rulesets/channels';
import { Template } from '../actionSteps';
import { State as CampaignState } from 'entities/lifecycle/lifeCycle';
import { uuid } from 'utils';

interface OwnProps {
  rulesetId: string;
  channelIndex: number;
  channel: ChannelEntity;
  campaignState: CampaignState;
}

export type Props = OwnProps;

export const Channel: React.FC<Props> = ({ rulesetId, channelIndex, channel, campaignState }) => {
  const { clientId } = useClientFromUrl();
  const type = channel?.type ?? '';

  switch (type) {
    case '.Email':
    case '.ScheduledChannel': {
      const emailChannel: EmailChannel =
        type === '.ScheduledChannel' ? getEmailChannel(channel as ScheduledChannel) : (channel as EmailChannel);
      // Older existing channels may not have a cycleId; use a copy so we never mutate the prop.
      const channelToUse: EmailChannel =
        emailChannel.cycleId === undefined ? { ...emailChannel, cycleId: uuid() } : emailChannel;
      return (
        <Template
          channelIndex={channelIndex}
          rulesetId={rulesetId}
          channel={channelToUse}
          allowChannelScheduling={true}
          campaignState={campaignState}
          siteId={clientId}
        />
      );
    }
    case '.RTMOverlayChannel':
    case '.RTMInjectedChannel':
      return (
        <Template
          channelIndex={channelIndex}
          rulesetId={rulesetId}
          channel={channel as TemplateChannel}
          campaignState={campaignState}
          siteId={clientId}
        />
      );
    default:
      return null;
  }
};
